<template>
  <div class="TheFooterSocialLinks social-footer">
    <ul class="social-footer__list">
      <li class="social-footer__list-item">
        <a
          :href="CONTACTS.twitter"
          rel="noopener nofollow"
          target="_blank"
          class="social-footer__list-item-link link-with-opacity"
        >
          <BaseImage
            class="social-footer__list-item-icon"
            :src="require(`images/icons/white-twitter.svg`)"
            alt="twitter icon"
            aria-label="twitter icon"
          />
          <span class="social-footer__list-item-hidden">Twitter</span>
        </a>
      </li>
      <li class="social-footer__list-item">
        <a
          :href="CONTACTS.facebook"
          rel="noopener nofollow"
          target="_blank"
          class="social-footer__list-item-link link-with-opacity"
        >
          <BaseImage
            class="social-footer__list-item-icon is--facebook"
            :src="require(`images/icons/white-facebook-f.svg`)"
            alt="facebook icon"
            aria-label="facebook icon"
          />
          <span class="social-footer__list-item-hidden">Facebook</span>
        </a>
      </li>
      <li class="social-footer__list-item">
        <a
          :href="CONTACTS.instagram"
          rel="noopener nofollow"
          target="_blank"
          class="social-footer__list-item-link link-with-opacity"
        >
          <BaseImage
            class="social-footer__list-item-icon"
            :src="require(`images/icons/white-instagram.svg`)"
            alt="instagram icon"
            aria-label="instagram icon"
          />
          <span class="social-footer__list-item-hidden">Instagram</span>
        </a>
      </li>
      <li class="social-footer__list-item">
        <a
          :href="CONTACTS.linkedin"
          rel="noopener nofollow"
          target="_blank"
          class="social-footer__list-item-link link-with-opacity"
        >
          <BaseImage
            class="social-footer__list-item-icon"
            :src="require(`images/icons/white-linkedin-in.svg`)"
            alt="linkedin icon"
            aria-label="linkedin icon"
          />
          <span class="social-footer__list-item-hidden">Linkedin</span>
        </a>
      </li>
      <li class="social-footer__list-item">
        <a
          :href="CONTACTS.youtube"
          rel="noopener nofollow"
          target="_blank"
          class="social-footer__list-item-link link-with-opacity"
        >
          <BaseImage
            class="social-footer__list-item-icon"
            :src="require(`images/icons/white-youtube.svg`)"
            alt="youtube icon"
            aria-label="youtube icon"
          />
          <span class="social-footer__list-item-hidden">YouTube</span>
        </a>
      </li>
      <li class="social-footer__list-item">
        <a
          :href="RSS_LINK"
          rel="noopener nofollow"
          target="_blank"
          class="social-footer__list-item-link link-with-opacity"
        >
          <BaseImage
            class="social-footer__list-item-icon"
            :src="require(`images/icons/white-rss.svg`)"
            alt="rss icon"
            aria-label="rss icon"
          />
          <span class="social-footer__list-item-hidden">RSS</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CONTACTS from 'Config/contacts.json';
import CONFIG from 'Config';
import BaseImage from 'Components/Base/BaseImage.vue';

export default defineComponent({
  name: 'TheFooterSocialLinks',
  components: {
    BaseImage,
  },
  setup() {
    return {
      CONTACTS,
      RSS_LINK: CONFIG.urls.rssLink,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.social-footer
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: flex-start
  &__list
    display: flex
    list-style-type: none
    padding-left: 0
    width: 100%
    @media screen and (max-width: 1024px)
      margin-bottom: 0
    @media screen and (max-width: 1000px)
      max-width: 350px
      justify-content: space-between
    @media screen and (max-width: 991px)
      margin-bottom: 0
  &__list-item
    padding-bottom: 0
    margin-right: 20px
    width: 20px
    &:last-child
      margin-right: 0
  &__list-item-icon
    +mt(.3s)
  &__list-item-link
    display: flex
    @media screen and (max-width: 767px)
      line-height: 20px
    &:hover
      .social-footer__list-item-icon
        +mt(.3s)
        opacity: 0.8
  &__list-item-hidden
    font-size: 0
    text-indent: 100%
    white-space: nowrap
    overflow: hidden
  &__list-item-icon
    height: 20px
    width: 100%
    &.is--facebook
      width: 11px
</style>
